import { Breadcrumb } from 'react-bootstrap';
import './BreadCrumb.scss';

const BreadCrumb = ({ items = [] }) => {
    if (!items.length) return null;

    return (
        <Breadcrumb className="bread-crumb">
            {items.map((item, index) =>
                item.href ? (
                    <Breadcrumb.Item key={index} href={item.href}>
                        {item.label}
                    </Breadcrumb.Item>
                ) : (
                    <Breadcrumb.Item key={index} active>
                        {item.label}
                    </Breadcrumb.Item>
                )
            )}
        </Breadcrumb>
    );
};

export default BreadCrumb;
